import React, { useState } from 'react'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const TopAppraisal = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();

        // Calculate relative position (-50 to 50 range)
        const x = ((clientX - left) / width - 2) * 20; // Text movement
        const y = ((clientY - top) / height - 1) * 20;

        const bgX = ((clientX - left) / width - 5) * 30; // Background movement
        const bgY = ((clientY - top) / height - 0.5) * 30;

        setPosition({ x, y, bgX, bgY });
    };
    return (
        <>
            {/* <section className='top-appraisal-wrap wow reveal fadeIn'>
                <div className="mouse-container">
                    <div className='top-appraisal-overlay'></div>
                    <div className='container container-lg'>
                        <div className='w-100 text-center mouse-text'>
                            <div className='d-flex align-items-center top-appraisal-flex'>
                                <div className='w-100'>
                                    <div className='xl-title text-uppercase text-center wow reveal fadeInUp'>TOP DOLLAR APPRAISAL</div>
                                    <div className='lg-title text-uppercase text-center fw-500 mt-4 wow reveal fadeInUp'>Looking to sell your Mercedes?</div>
                                    <div className='text-center mt-5 wow reveal fadeInUp'>
                                        <button type='button' className='black-btn get-started-btn w-240 text-uppercase'>Get Started</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            
            <section className='top-appraisal-wrap'>
                <div className="mouse-container" onMouseMove={handleMouseMove}>
                    {/* Background Move Effect */}
                    <motion.div
                        className="mouse-background"
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />
                    
                    <div className='w-100 text-center mouse-text'>
                       
                        <h3 className='xl-title text-uppercase text-center wow reveal fadeInUp'>TOP DOLLAR APPRAISAL</h3>
                        <div className='lg-title text-uppercase text-center fw-500 mt-4 wow reveal fadeInUp'>Looking to sell your Mercedes?</div>
                        <div className='text-center mt-5 wow reveal fadeInUp'>
                            <Link to="/sell-your-car" className='black-btn get-started-btn w-240 text-uppercase'>Get Started</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TopAppraisal